<script>
	export let data;
	import JSONTree from "svelte-json-tree";
	import Spinner from "./spinner.svelte";
	import CollapsibleSection from "./CollapsibleSection.svelte";
	import * as urls from "../json/config.json";
	import { token, role } from "./store";

	let value;
	let httpHeaderVal;
	let emailVal = [];
	let history = {};

	let report_message = "Domain has been reported";
	let reported = false;

	let promise = init()
	
	async function init() {
		value = data;
		for (const row of value.selectors) {
			if (row.type == "HTTP Header") {
				httpHeaderVal = row.data;
			} else if (row.type == "Email") {
				emailVal.push(row.data);
			}
		}

		for (const row of value.history_logs){
			let date = row.timestamp.split(".")[0]
			history[date] ??= {};
			history[date][row.service] = row.status
		}
	}

	const reportAbuse = async (domain) => {
		let urlWithParams = `${urls.reportabuse}?domain=${domain}`;
		try{
			const response = await fetch(urlWithParams, {
				method: 'GET',
				headers: {
					'Authorization': 'Bearer ' + $token
				},
			});
			console.log("made it past fetch");
			console.log(response);
			if(response.ok) {
				console.log("response OK");
				reported = true;

				setTimeout(() => {
					reported = false;
				}, 3000);
			} else {
				report_message = "Error Reporting Domain";
				reported = true;

				setTimeout(() => {
					reported = false;
				}, 3000);
			}
		} catch(error) {
			report_message = "Error Reporting Domain";
			reported = true;

			setTimeout(() => {
				reported = false;
			}, 3000);

			throw new Error("An error occurred: ", error);
		}
	}
</script>

{#await promise}
	<Spinner />
{:then}
	{#if value}
		<div class="header">
			{#if $role === "guest"}
				<button class="report-abuse" on:click={reportAbuse(value.hidden_service.domain)}>
					Flag CSAM content
				</button>
			{/if}
			{#if value.hidden_service.language != ""}
				<p class="title">{value.hidden_service.title}</p>
			{/if}

			<span>Domain: {value.hidden_service.domain}</span><br />

			{#if value.hidden_service.language != ""}
				<span>Locale: {value.hidden_service.language}</span><br />
			{/if}

			<span>First Logged: {value.hidden_service.first_seen}</span>
		</div>
		<p class="sub-header">Supported Protocols</p>
		<div class="border">
			<table class="proto-table" width="100%">
				<thead>
					<tr>
						<th width="100px;">Service</th>
						<th>Status</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>HTTP</td>
						{#if value.hidden_service.http == false}
							<td>❌</td>
						{:else}
							<td>✅</td>
						{/if}
					</tr>
					<tr>
						<td>SMTP</td>
						{#if value.hidden_service.smtp == false}
							<td>❌</td>
						{:else}
							<td>✅</td>
						{/if}
					</tr>
					<tr>
						<td>SSH</td>
						{#if value.hidden_service.ssh == false}
							<td>❌</td>
						{:else}
							<td>✅</td>
						{/if}
					</tr>
					<tr>
						<td>SSL</td>
						{#if value.hidden_service.ssl == false}
							<td>❌</td>
						{:else}
							<td>✅</td>
						{/if}
					</tr>
					<tr>
						<td>XMPP</td>
						{#if value.hidden_service.xmpp == false}
							<td>❌</td>
						{:else}
							<td>✅</td>
						{/if}
					</tr>
				</tbody>
			</table>
		</div>

		{#if emailVal != "" && emailVal != undefined}
			<p class="sub-header">Email</p>
			<div class="selectors border">
				{#each emailVal as row}
					<span>{row}</span><br />
				{/each}
			</div>
			{#if httpHeaderVal != "" && httpHeaderVal != undefined}
				<p class="sub-header">HTTP Header</p>
				<div class="selectors border">
					<p class="sub-header"><JSONTree value={httpHeaderVal} /></p>
				</div>
			{/if}

			{#if emailVal != "" && emailVal != undefined}
				<p class="sub-header">Email</p>
				<div class="selectors border">
					{#each emailVal as row}
						<span>{row}</span><br />
					{/each}
				</div>
			{/if}

			{#each value.selectors as row}
				{#if row.type != "HTTP Header" && row.type != "Email" && row.data != ""}
					<p class="sub-header">{row.type}</p>
					<div class="selectors border">
						<span>{row.data}</span>
					</div>
				{/if}
			{/each}
		
			{#if Object.keys(history).length > 0}
				<p class="sub-header">History</p>
				<div class="history border">
					{#each Object.entries(history) as [timestamp, props]}
						<CollapsibleSection headerText={timestamp} >
							<table width="98%">
								<thead class="cols">
									<tr>
										<th>Property</th>
										<th>Value</th>
									</tr>
								</thead>
								{#each Object.entries(props) as [property, value]}
									<tr>
										<td>{property}</td>
										<td>{value}</td>
									</tr>
								{/each}
							</table>
						</CollapsibleSection>
					{/each}
				</div>
			{/if}
		{/if}
	{:else}
		<h3 style="text-align: center">
			This domain has not yet been crawled.
		</h3>
	{/if}

	{#if httpHeaderVal != "" && httpHeaderVal != undefined}
		<p class="sub-header">HTTP Header</p>
		<div class="selectors border">
			<p class="sub-header"><JSONTree value={httpHeaderVal} /></p>
		</div>
	{/if}
{/await}

{#if reported}
		<p class="report-msg">{report_message}</p>
{/if}

<style>
	.border {
		border-style: solid;
		border-width: 3px;
		border-image-source: linear-gradient(112deg, #9c0ccf 0%, #5157d4 100%);
		border-image-slice: 1;
	}
	th,
	td {
		color: #eee;
		padding: 5px;
		text-align: left;
	}
	.title {
		font-size: 1.1rem;
	}
	.header {
		margin: 2px 2px 10px 2px;
		display: flex;
		flex-direction: column;
	}
	.sub-header {
		font-size: 1rem;
	}
	.proto-table {
		border-collapse: collapse;
	}
	.history th,
	.history td,
	.proto-table th,
	.proto-table td {
		border: 1px solid #7d7e81;
		padding-left: 10px;
	}
	.selectors {
		color: #eee;
		padding: 10px;
		--json-tree-string-color: yellow;
		--json-tree-property-color: #eee;
		--json-tree-operator-color: #ddd;
		--json-tree-arrow-color: #fff;
	}
	.history{
		padding: 10px;
	}
	.history table{
		border: 1px solid #7d7e81;
		border-collapse: collapse;
		margin:10px;
	}
	.report-abuse{
		cursor: pointer;
		color: #81edf5;
        background: transparent;
        border: 0;
		background-color: #1e1e1e;
		text-decoration: underline;
		margin-left: auto;
		margin-right: 50px;
	}
	.report-msg{
		position: absolute;
		color: #fff;
		text-align: center;
		left: 0;
		right: 0;
		top: 0;
		margin-top: 22px;
	}
</style>
